import { PhotoIcon } from '../../automationStudioIcons';
import styles from '../../../../styles/automationStudio/automationStudio.module.scss';

export const SCREENSHOT_PLACEHOLDER_VARIANTS = {
    loading: 'Loading preview…',
    waiting: 'Waiting for preview…',
    empty: 'No screenshot captured',
    unavailable: 'Image unavailable',
    notApplicable: 'This tool does not produce a screenshot',
    pending: 'No screenshot available',
};

const SUBTITLES = {
    pending: 'Screenshot will be captured during execution',
};

const SIZE_CLASS = {
    card: styles.verificationScreenshotPlaceholderArea,
    thumbnail: styles.screenshotPlaceholderThumbnail,
    panel: styles.screenshotPlaceholderPanel,
};

/**
 * Shared empty / loading screenshot state for execution, verification, and step preview UIs.
 */
export default function ScreenshotPlaceholder({
    variant = 'empty',
    size = 'card',
    subtitle,
    className = '',
}) {
    const title = SCREENSHOT_PLACEHOLDER_VARIANTS[variant] ?? SCREENSHOT_PLACEHOLDER_VARIANTS.empty;
    const detail = subtitle ?? SUBTITLES[variant] ?? null;
    const isLoading = variant === 'loading';
    const iconClass =
        size === 'thumbnail'
            ? styles.screenshotPlaceholderIconSm
            : styles.verificationScreenshotPlaceholderIcon;
    const labelClass = [
        styles.verificationScreenshotPlaceholderLabel,
        size === 'thumbnail' ? styles.screenshotPlaceholderLabelSm : '',
    ].filter(Boolean).join(' ');

    return (
        <div
            className={[SIZE_CLASS[size] ?? SIZE_CLASS.card, className].filter(Boolean).join(' ')}
            role="status"
            aria-live="polite"
            aria-label={title}
        >
            {isLoading ? (
                <span className={`${styles.asSpinner} ${styles.asSpinnerSm}`} aria-hidden />
            ) : (
                <PhotoIcon className={iconClass} aria-hidden />
            )}
            <span className={labelClass}>{title}</span>
            {detail ? (
                <span className={`${styles.screenshotPlaceholderSubtitle} ${styles.asTypoCaption}`}>
                    {detail}
                </span>
            ) : null}
        </div>
    );
}
